import { render } from "./Markdown.vue?vue&type=template&id=32873945&bindings={\"text\":\"data\",\"debounce\":\"data\",\"markedText\":\"options\",\"update\":\"options\"}"
import script from "./Markdown.vue?vue&type=script&lang=js"
export * from "./Markdown.vue?vue&type=script&lang=js"
script.render = render

export default script